import React, { useEffect, useState } from "react";
import axios from "axios";
import ReceiptPageView from "components/receiptPage/ReceiptPageView";
import { getApiUrl } from "util/apiUrl";
import usePublicPageScroll from "hooks/usePublicPageScroll";

export default function ReceiptPreview(props) {
  usePublicPageScroll();
  const storeId = Number(props.match?.params?.storeId);
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .post(`${getApiUrl()}user/receiptPreviewByStore`, {
        storeId
      })
      .then(res => setReceiptData(res.data.data))
      .catch(err => console.error("Preview load failed", err))
      .finally(() => setLoading(false));
  }, [storeId]);

  return (
    <ReceiptPageView receiptData={receiptData} loading={loading} previewMode />
  );
}
